<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="cover">
    <div
      v-move="{
        pos: props[item.posKey],
        change: (left:number, top:number) => onPosChange(item.posKey, left, top)
      }"
      v-input="{
        value: props[item.valueKey],
        change: (value:string) => onValueChange(item.valueKey, value)
      }"
      v-for="(item, index) in info"
      :data-edit="useEdit"
      :key="index"
      :class="{ [item.className]: true }"
      v-html="props[item.valueKey]"
    ></div>
    <div v-html="svg" class="svg"></div>
  </div>
</template>

<script setup lang="tsx">
import { withDefaults, defineProps, defineEmits } from 'vue';

import { vMove, vInput, useCover } from './index';
type Pos = { left: number; top: number; center?: boolean; initHeight?: number };
const props = withDefaults(
  defineProps<{
    useEdit?: boolean;
    projectName: string;
    time: string;
    mainPageEnterpriseName: string;
    titlePosition: Pos;
    settleTimePosition: Pos;
    aspNamePosition: Pos;
    orderNumber: string | number;
    orderNumberPostion: Pos;
  }>(),
  {}
);

const emits = defineEmits(['posChange', 'valueChange']);

const svg = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1348.365 1419.766">
  <g transform="translate(1.254 -89)">
    <g id="fengmian5">
      <path d="M-16541.053-6774.65l138.15,154.7-138.15,154.491h-488.174V-6774.65Z" transform="translate(17029.227 7909)" fill="var(--theme-color-1)"/>
      <path d="M-16487.465-6773.994h683.208v150.174h-548.758Z" transform="translate(16999.258 7908)" fill="var(--theme-color-1)"/>
      <path d="M-14993.666-7990l21.639,28.552-21.639,26.045h-277.588V-7990Z" transform="translate(15270 8079)" fill="var(--theme-color-1)"/>
      <path d="M-15219.615-7990l-21.639,28.552,21.639,26.045h277.588V-7990Z" transform="translate(16135.281 8079)" fill="var(--theme-color-1)"/>
      <path d="M-16098.762-6601.751h212.736l-121.941,137.1h-216.377Z" transform="translate(16736.137 7908.187)" fill="#26292e"/>
      <path d="M-16098.762-6601.751h472.736l-121.941,137.1h-476.377Z" transform="translate(16973.137 7908.187)" fill="#26292e"/>
    </g>
    <line x2="667" transform="translate(262.5 1507.266)" fill="none" stroke="#8e8e8e" stroke-width="3"/>
  </g>
</svg>

`;

const { info, onPosChange, onValueChange } = useCover(emits);
</script>
<style lang="scss" scoped>
.cover {
  height: calc(var(--page-v3-height, 100%) - 2px);
  position: relative;
}
.svg {
  width: calc(100% + 160px);
  height: calc(100% + 20px);
  position: absolute;
  left: 0px;
  top: 80px;
}

.project-name,
.time,
.order-number,
.enterprise-name {
  position: absolute;
  z-index: 2;
  user-select: none;
  font-weight: 600;
}
.project-name,
.time {
  font-size: 63px;
  color: #404040;
}

.project-name {
  width: 850px;
}
.time {
  max-width: 690px;
  font-size: 36px;
  min-width: 250px;
  text-align: center;
  color: #484848;
}
.enterprise-name {
  font-size: 32px;
  text-align: center;
  width: 500px;
  color: #484848;
}
.order-number {
  font-size: 46px;
  font-weight: 500;
  color: #484848;
  font-family: PingFang SC;
  font-weight: 600;
}
</style>
